import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { fetchNews } from "../lib/api";
import { useCachedData } from "../lib/useCachedData";
import { useSEO } from "../hooks/useSEO";

const THUMBS = [
  "https://images.unsplash.com/photo-1485802240079-a8245c843b95?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1590585382453-8b749e9d5224?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1641531105535-1ead3c1784ab?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1510925758641-869d353cecc7?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
];

function formatLong(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function Blog() {
  const { data } = useCachedData("mst:news", fetchNews);
  const items = data?.items || [];

  useSEO({
    title: "Live Updates & Blog | Morning Sunday Teer",
    description:
      "Latest Morning Sunday Teer updates, result recaps, common number guides and tips. Stay informed with fast, accurate daily news.",
    path: "/blog/",
  });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumbs items={[{ label: "Live Updates & Blog" }]} />
      <h1 className="font-head font-black text-3xl sm:text-4xl text-slate-900 mb-2">
        Latest Updates &amp; News
      </h1>
      <p className="text-slate-600 max-w-3xl mb-8 text-[15px]">
        Fast, accurate Morning Sunday Teer result recaps, common number guides and helpful tips —
        updated regularly.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((n, i) => (
          <article
            key={n.id}
            data-testid={`blog-card-${i}`}
            className="bg-white rounded-xl border border-slate-200 card-shadow overflow-hidden flex flex-col"
          >
            <div className="aspect-[16/10] overflow-hidden bg-slate-100">
              <img src={THUMBS[i % THUMBS.length]} alt={n.title} loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <span className="flex items-center gap-1 text-xs text-[#ff4500] font-semibold mb-2">
                <CalendarDays size={13} /> {formatLong(n.date)} · {n.category}
              </span>
              <h2 className="font-head font-bold text-lg text-slate-900 leading-snug">{n.title}</h2>
              <p className="text-sm text-slate-600 mt-2 flex-1">{n.excerpt}</p>
              <span className="mt-3 text-[#ff4500] text-sm font-semibold flex items-center gap-1">
                Read More <ArrowRight size={14} />
              </span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
